import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, Card, CardBody, Col, Row } from 'react-bootstrap';

function FilterButtons({ data, onStatusChange, previousSelectedStatus }) {
  const [selected, setSelected] = useState(previousSelectedStatus || '');

  const handleClick = (status) => {
    setSelected(status);
    onStatusChange(status);
  };

  const getButtonClass = (status) =>
    classNames(status !== selected ? 'btn-soft-primary' : 'btn-primary');

  return (
    <Row>
      <Col>
        <Card>
          <CardBody>
            <div className="d-flex gap-2 flex-wrap">
              <Button
                className={classNames('rounded-pill', getButtonClass(''))}
                onClick={() => handleClick('')}
              >
                All
              </Button>
              {Object.entries(data).map(([status, label]) => (
                <Button
                  key={status}
                  className={classNames('rounded-pill', getButtonClass(status))}
                  onClick={() => handleClick(status)}
                >
                  {label}
                </Button>
              ))}
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}

FilterButtons.propTypes = {
  data: PropTypes.object.isRequired,
  onStatusChange: PropTypes.func.isRequired,
};

export default FilterButtons;
